/* js/components/Menu.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	append,
	attr,
	bubble,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	toggle_class
} from "svelte/internal";

import { appRouter } from '../appRouter.js';
import { onMount } from 'svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i];
	return child_ctx;
}

// (200:8) {#if menuItem.icon_url}
function create_if_block(ctx) {
	let img;
	let img_src_value;

	return {
		c() {
			img = element("img");
			if (!src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*menuItem*/ ctx[4].icon_url))) attr(img, "src", img_src_value);
			attr(img, "class", "svelte-nhhoxt");
		},
		m(target, anchor) {
			insert(target, img, anchor);
		},
		p(ctx, dirty) {
			if (dirty & /*menuItems*/ 2 && !src_url_equal(img.src, img_src_value = appRouter.normalizePath(/*menuItem*/ ctx[4].icon_url))) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(img);
		}
	};
}

// (198:8) {#each menuItems as menuItem}
function create_each_block(ctx) {
	let div;
	let t0;
	let a;
	let t1_value = /*menuItem*/ ctx[4].name + "";
	let t1;
	let a_href_value;
	let t2;
	let if_block = /*menuItem*/ ctx[4].icon_url && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block) if_block.c();
			t0 = space();
			a = element("a");
			t1 = text(t1_value);
			t2 = space();
			attr(a, "href", a_href_value = appRouter.normalizePath(/*menuItem*/ ctx[4].path));
			attr(a, "class", "svelte-nhhoxt");
			attr(div, "class", "navitem svelte-nhhoxt");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			if (if_block) if_block.m(div, null);
			append(div, t0);
			append(div, a);
			append(a, t1);
			append(div, t2);
		},
		p(ctx, dirty) {
			if (/*menuItem*/ ctx[4].icon_url) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(div, t0);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*menuItems*/ 2 && t1_value !== (t1_value = /*menuItem*/ ctx[4].name + "")) set_data(t1, t1_value);

			if (dirty & /*menuItems*/ 2 && a_href_value !== (a_href_value = appRouter.normalizePath(/*menuItem*/ ctx[4].path))) {
				attr(a, "href", a_href_value);
			}
		},
		d(detaching) {
			if (detaching) detach(div);
			if (if_block) if_block.d();
		}
	};
}

function create_fragment(ctx) {
	let aside;
	let h2;
	let t1;
	let nav;
	let div0;
	let t2;
	let t3;
	let div3;
	let t5;
	let div4;
	let mounted;
	let dispose;
	let each_value = /*menuItems*/ ctx[1];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			aside = element("aside");
			h2 = element("h2");
			h2.textContent = "hypercity";
			t1 = space();
			nav = element("nav");
			div0 = element("div");
			t2 = space();

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t3 = space();
			div3 = element("div");

			div3.innerHTML = `<div class="logo-bm svelte-nhhoxt"><img class="logo svelte-nhhoxt" src="/images/logo_bm.png" alt=""/></div> 

            <div class="logo-ville svelte-nhhoxt"><img class="logo svelte-nhhoxt" src="/images/logo_ville.png" alt=""/></div>`;

			t5 = space();
			div4 = element("div");
			attr(div0, "class", "separator svelte-nhhoxt");
			attr(nav, "class", "svelte-nhhoxt");
			attr(div3, "class", "aside-footer svelte-nhhoxt");
			attr(aside, "class", "_menu box-shadow svelte-nhhoxt");
			toggle_class(aside, "open", /*open*/ ctx[0]);
			attr(div4, "class", "full-screen-catcher svelte-nhhoxt");
			toggle_class(div4, "hidden", !/*open*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, aside, anchor);
			append(aside, h2);
			append(aside, t1);
			append(aside, nav);
			append(nav, div0);
			append(nav, t2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(nav, null);
			}

			append(aside, t3);
			append(aside, div3);
			insert(target, t5, anchor);
			insert(target, div4, anchor);

			if (!mounted) {
				dispose = listen(div4, "click", /*click_handler*/ ctx[2]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*appRouter, menuItems*/ 2) {
				each_value = /*menuItems*/ ctx[1];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(nav, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*open*/ 1) {
				toggle_class(aside, "open", /*open*/ ctx[0]);
			}

			if (dirty & /*open*/ 1) {
				toggle_class(div4, "hidden", !/*open*/ ctx[0]);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(aside);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t5);
			if (detaching) detach(div4);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { open } = $$props;

	const _menuItems = [
		{
			name: "Accueil",
			path: "/",
			icon_url: '/_icons/menu-accueil2.svg'
		},
		{
			name: "Parcours",
			path: "/parcours",
			icon_url: '/_icons/menu-parcours2.svg'
		},
		{
			name: "Événements",
			path: "/evenements",
			icon_url: '/_icons/menu-parcours2.svg'
		},
		{
			name: "À propos",
			path: "/a_propos",
			icon_url: '/_icons/menu-a-propos2.svg'
		}
	];

	let menuItems = [];

	// Hide menu item for current page
	onMount(() => {
		// pathname with trailing / removed (if present) 
		// and base address removed if not hosted at root
		let pathname = new URL(window.location.href).pathname.replace(appRouter.getBase(), "");

		if (pathname.length > 1 && pathname.endsWith('/')) {
			pathname = pathname.substr(0, pathname.length - 1);
		}

		// console.log("pathName", pathname);
		$$invalidate(1, menuItems = []); // force reactivity

		for (let i = 0; i < _menuItems.length; i++) {
			const path = _menuItems[i].path;

			if (path !== pathname) {
				menuItems.push(_menuItems[i]);
			}
		}
	});

	function click_handler(event) {
		bubble.call(this, $$self, event);
	}

	$$self.$$set = $$props => {
		if ('open' in $$props) $$invalidate(0, open = $$props.open);
	};

	return [open, menuItems, click_handler];
}

class Menu extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { open: 0 });
	}
}

export default Menu;